import { SelectTagsDialogComponent } from './../tags/select-tags-dialog/select-tags-dialog.component';
import { TagDto } from './../../../../data-transfer/entities/tag-dto';
import { PackagingUnitInfoDto } from '../../../../data-transfer/entities/packaging-unit-entities/packaging-unit-info-dto';
import { CompositeMaterialsOverviewComponent } from './../composite-materials-overview/composite-materials-overview.component';
import { MultiMaterialCompositeDto } from 'src/app/data-transfer/entities/material-entities/multi-material-composite-dto';
import { ContextMenuService } from '../../services/context-menu-service';
import { DirectoryDto } from 'src/app/data-transfer/entities/directory-dto';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { ActivatedRoute } from '@angular/router';

import { PermissionTypeDto } from '../../../../data-transfer/entities/permission-type-dto';
import { PackagingComponentsOverviewComponent } from '../packaging-components-overview/packaging-components-overview.component';
import { PackagingComponentDto } from '../../../../data-transfer/entities/component-entities/packaging-component-dto';
import {Component, OnInit, ViewChild, OnDestroy, TemplateRef, ChangeDetectorRef } from '@angular/core';
import {forkJoin,Observable,Subscription,iif,of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { PackagingSystemInfoDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-info-dto';
import { PackagingSystemsOverviewComponent } from '../packaging-systems-overview/packaging-systems-overview.component';
import { DirectoryTreeComponent, RECYCLING_BIN_ID } from '../directory-tree/directory-tree.component';
import { OverviewTableComponent } from 'src/app/components/shared-components/parent-components/overview-table/overview-table.component';
import { ToolbarDirectoryComponent } from '../toolbar-directory/toolbar-directory.component';
import { MultiMaterialCompositeImportWrapper } from 'src/app/components/dialogs/selection-dialog-materials/selection-dialog-materials.component';
import { Location } from '@angular/common';
import { ComponentText, FolderIdsQueryParam, MaterialText, PackagingSystemText, PackagingUnitText } from 'src/app/model/path-building-blocks';
import { PaginationDataSource, PaginationEndpoint } from 'src/app/util/pagination-datasource';
import { PackagingUnitApiService } from 'src/app/data-transfer/services/packaging-unit-api-service';
import { PackagingUnitsOverviewComponent } from '../packaging-units-overview/packaging-units-overview.component';
import { PackagingSystemApiService } from 'src/app/data-transfer/services/packaging-system-api-service';
import { ComponentApiService } from 'src/app/data-transfer/services/component-api-service';
import { MaterialApiService } from 'src/app/data-transfer/services/material-api-service';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { PackagingSystemDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-dto';
import { DirectoryStateService } from '../../services/directory-state.service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { PpwrApiService } from 'src/app/data-transfer/services/ppwr-api.service';
import { PpwrPackagingInfoDto } from 'src/app/data-transfer/entities/ppwr-entities/ppwr-packaging-info-dto';
import { SetPpwrApprovedRequestDto } from 'src/app/data-transfer/entities/ppwr-entities/set-ppwr-approved-request-dto';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { PackagingPpwrOverviewComponent } from '../packaging-ppwr-overview/packaging-ppwr-overview.component';
import { UserApiService } from 'src/app/data-transfer/services/user-api-service';
import { UserProfileDto } from 'src/app/data-transfer/entities/user-profile-dto';

@Component({
  selector: 'app-directory-management',
  templateUrl: './directory-management.component.html',
  styleUrls: ['./directory-management.component.scss'],
})
export class DirectoryManagementComponent implements OnInit, OnDestroy {
  private packagingSystemsTable?: PackagingSystemsOverviewComponent;
  private packagingUnitsTable?: PackagingUnitsOverviewComponent;
  private componentsTable?: PackagingComponentsOverviewComponent;
  private materialsTable?: CompositeMaterialsOverviewComponent;

  @ViewChild(PackagingSystemsOverviewComponent) set packagingSystemsOverviewComponent(packagingSystemsTable: PackagingSystemsOverviewComponent) {
    if (packagingSystemsTable) {
      this.packagingSystemsTable = packagingSystemsTable;
      this.setCurrentPackagingPartTable();
      this.updateIsEnterQuantitiesAllowed();
    }
  }
  @ViewChild(PackagingUnitsOverviewComponent) set packagingUnitsOverviewComponent(packagingUnitsTable: PackagingUnitsOverviewComponent) {
    if (packagingUnitsTable) {
      this.packagingUnitsTable = packagingUnitsTable;
      this.setCurrentPackagingPartTable();
      this.updateIsEnterQuantitiesAllowed();
    }
  }
  @ViewChild(PackagingComponentsOverviewComponent) set packagingComponentsOverviewComponent(componentsTable: PackagingComponentsOverviewComponent) {
    if (componentsTable) {
      this.componentsTable = componentsTable;
      this.setCurrentPackagingPartTable();
      this.updateIsEnterQuantitiesAllowed();
    }
  }
  @ViewChild(CompositeMaterialsOverviewComponent) set compositeMaterialsOverviewComponent(materialsTable: CompositeMaterialsOverviewComponent) {
    if (materialsTable) {
      this.materialsTable = materialsTable;
      this.setCurrentPackagingPartTable();
      this.updateIsEnterQuantitiesAllowed();
    }
  }

  @ViewChild('ppwrSystemTable') packagingPpwrSystemTable?: PackagingPpwrOverviewComponent;
  @ViewChild('ppwrUnitTable') packagingPpwrUnitTable?: PackagingPpwrOverviewComponent;

  private get packagingPpwrTable(): PackagingPpwrOverviewComponent | undefined {
    return this.selectedPackagingPartTab === PackagingPart.System ? this.packagingPpwrSystemTable : this.packagingPpwrUnitTable;
  }

  @ViewChild(ToolbarDirectoryComponent) private toolbar!: ToolbarDirectoryComponent;
  @ViewChild(DirectoryTreeComponent) directoryTree!: DirectoryTreeComponent;
  @ViewChild('contextMenu') contextMenu!: TemplateRef<any>;

  selectedFolderIds: number[] = [];
  autoSelectSubfolders = true;
  expandedFolderIds: number[] = [];
  rootDtoFolder!: DirectoryDto;
  selectedDtoFolder?: DirectoryDto;
  selectedEntryIds: number[] = [];
  selectedPackagingPartTab = PackagingPart.System;

  private currentPackagingPartTable?: OverviewTableComponent;
  private currentDataSource?:
    | PaginationDataSource<PackagingSystemInfoDto>
    | PaginationDataSource<PackagingUnitInfoDto>
    | PaginationDataSource<PackagingComponentDto>
    | PaginationDataSource<MultiMaterialCompositeImportWrapper>;

  directoryPermissions: PermissionTypeDto = new PermissionTypeDto();
  selectedFoldersPermissions: PermissionTypeDto = new PermissionTypeDto();

  recyclingBinId = RECYCLING_BIN_ID;
  isRecyclingBinSelected = false;
  isEnterQuantitiesAllowed = true;

  allTags: TagDto[] = [];
  packagingSystemsDataSource = new PaginationDataSource<PackagingSystemInfoDto>(x => this.packagingSystemPaginationEndpoint(x));
  packagingUnitsDataSource = new PaginationDataSource<PackagingUnitInfoDto>(x => this.packagingUnitPaginationEndpoint(x));
  componentsDataSource = new PaginationDataSource<PackagingComponentDto>(x => this.componentPaginationEndpoint(x));
  materialsDataSource = new PaginationDataSource<MultiMaterialCompositeImportWrapper>(x => this.materialPaginationEndpoint(x));
  packagingPpwrSystemDataSource = new PaginationDataSource<PpwrPackagingInfoDto>(x => this.ppwrApiService.getPpwrInfoForSystemsByPage(x));
  packagingPpwrUnitDataSource = new PaginationDataSource<PpwrPackagingInfoDto>(x => this.ppwrApiService.getPpwrInfoForUnitsByPage(x));

  displayedColumnsPackagingSystems = ['id', 'tracking', 'brandName', 'productName', 'articleNumber', 'supplier', 'tags', 'action', 'select'];
  displayedColumnsPackagingUnits = ['id', 'tracking', 'packagingTypeName', 'brandName', 'productName', 'articleNumber', 'supplier', 'tags', 'action', 'select'];
  displayedColumnsComponents = [
    'id',
    'tracking',
    'packagingComponentCategoryName',
    'packagingComponentSubtypeName',
    'articleName',
    'articleNumber',
    'manufacturer',
    'tags',
    'action',
    'select',
  ];
  displayedColumnsMaterials = ['id', 'tracking', 'articleName', 'articleNumber', 'manufacturerName', 'tags', 'action', 'select'];

  isPpwrViewEnabled = false;
  readonly packagingPartEnum = PackagingPart;

  userProfile: UserProfileDto = {};

  private routeDataSubscription?: Subscription;
  private getPermissionsSubscription?: Subscription;
  private selectedFoldersSubscription?: Subscription;
  private autoSelectSubfoldersSubscription?: Subscription;
  private expandedFoldersSubscription?: Subscription;
  private ppwrViewEnabledSubscription?: Subscription;
  private selectedFoldersPermissionsSubscription?: Subscription;
  private dialogSubscription?: Subscription;
  private getFoldersSubscription?: Subscription;
  private tagsSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private directoryApiService: DirectoryApiService,
    private packagingUnitApiService: PackagingUnitApiService,
    private packagingSystemApiService: PackagingSystemApiService,
    private componentApiService: ComponentApiService,
    private multiMaterialApiService: MaterialApiService,
    private contextMenuService: ContextMenuService,
    private dialog: MatDialog,
    private location: Location,
    private directoryStateService: DirectoryStateService,
    private ppwrApiService: PpwrApiService,
    private snackBar: MatSnackBar,
    private translateService: TranslocoService,
    private userApiService: UserApiService,
    private readonly cd: ChangeDetectorRef
  ) {}

  private packagingSystemPaginationEndpoint: PaginationEndpoint<PackagingSystemInfoDto> = paginationQuery => {
    return iif(
      () => this.isRecyclingBinSelected,
      this.packagingSystemApiService.getPackagingSystemsInRecyclingBinByPage(paginationQuery),
      this.packagingSystemApiService.getPackagingSystemsByPage(paginationQuery)
    );
  };

  private packagingUnitPaginationEndpoint: PaginationEndpoint<PackagingUnitInfoDto> = paginationQuery => {
    return iif(
      () => this.isRecyclingBinSelected,
      this.packagingUnitApiService.getPackagingUnitsInRecyclingBinByPage(paginationQuery),
      this.packagingUnitApiService.getPackagingUnitsByPage(paginationQuery)
    );
  };

  private componentPaginationEndpoint: PaginationEndpoint<PackagingComponentDto> = paginationQuery => {
    return iif(
      () => this.isRecyclingBinSelected,
      this.componentApiService.getComponentsInRecyclingBinByPage(paginationQuery),
      this.componentApiService.getComponentsByPage(paginationQuery)
    );
  };

  private materialPaginationEndpoint: PaginationEndpoint<MultiMaterialCompositeImportWrapper> = paginationQuery => {
    return iif(
      () => this.isRecyclingBinSelected,
      this.multiMaterialApiService.getMultiMaterialsInRecyclingBinByPage(paginationQuery),
      this.multiMaterialApiService.getMultiMaterialsByPage(paginationQuery)
    );
  };

  ngOnInit(): void {
    this.userApiService.getUserProfile().subscribe(profile => {
      this.userProfile = profile;
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      this.rootDtoFolder = data.rootDtoDirectory;
      this.allTags = data.allTags;
    });
    this.selectedFoldersSubscription = this.directoryStateService.getSelectedFolderIds().subscribe(folderIds => {
      this.selectedFolderIds = folderIds;
      this.setPermissionsForSelectedFolders(folderIds);
      this.setUrlToCurrentState();
    });
    this.autoSelectSubfoldersSubscription = this.directoryStateService.getAutoSelectSubfolders().subscribe(enabled => {
      this.autoSelectSubfolders = enabled;
    });
    this.ppwrViewEnabledSubscription = this.directoryStateService.getPpwrViewEnabled().subscribe(enabled => {
      this.isPpwrViewEnabled = enabled;
    });
    this.expandedFoldersSubscription = this.directoryStateService.getExpandedFolderIds().subscribe(folderIds => {
      this.expandedFolderIds = folderIds;
    });

    this.route.params.subscribe(params => {
      const initialFolderIds = this.getFolderIdsFromQueryParam();

      if (initialFolderIds.length > 0) {
        this.onFoldersSelected(initialFolderIds);
      }

      if (params.packagingType) {
        switch (params.packagingType) {
          case PackagingSystemText:
            this.selectedPackagingPartTab = PackagingPart.System;
            break;
          case PackagingUnitText:
            this.selectedPackagingPartTab = PackagingPart.Unit;
            break;
          case ComponentText:
            this.selectedPackagingPartTab = PackagingPart.Component;
            break;
          case MaterialText:
            this.selectedPackagingPartTab = PackagingPart.Material;
            break;
          default:
            this.selectedPackagingPartTab = PackagingPart.System;
            break;
        }
      }

    this.directoryStateService.getFolderAndTab().subscribe(state => {
      if (state) {
          this.selectedPackagingPartTab = state.tabIndex;
      }
         this.validPackagingPartTab();
         this.setCurrentPackagingPartTable();
      });
      this.cd.detectChanges();
    });
  }

  private validPackagingPartTab(): void {
    if (this.isPpwrViewEnabled && (this.selectedPackagingPartTab === PackagingPart.Component || this.selectedPackagingPartTab === PackagingPart.Material)) {
      this.selectedPackagingPartTab = PackagingPart.System;
    }
  }

  onRecyclingBinSelected(recyclingBinFolder: DirectoryDto): void {
    this.selectedDtoFolder = recyclingBinFolder;

    this.isRecyclingBinSelected = true;

    this.onFoldersSelected([]);

    this.setPermissionsForCurrentFolder(recyclingBinFolder.id);

    this.directoryStateService.saveFolderAndTab(recyclingBinFolder.id, this.selectedPackagingPartTab).subscribe();
  }

  onContextMenuOpened(dtoFolder: DirectoryDto): void {
    this.selectedDtoFolder = dtoFolder;

    this.setPermissionsForCurrentFolder(dtoFolder.id);
  }

  onFoldersSelected(folderIds: number[]): void {
    this.selectedFolderIds = folderIds;

    this.setPermissionsForSelectedFolders(folderIds);

    this.directoryStateService.saveSelectedFolders(folderIds).subscribe();

    this.setUrlToCurrentState();

    if (folderIds.length > 0) {
      this.isRecyclingBinSelected = false;
    }
    if (folderIds.length === 0) {
      this.packagingUnitsDataSource.clear();
      this.packagingSystemsDataSource.clear();
      this.componentsDataSource.clear();
      this.materialsDataSource.clear();
    }

    if (folderIds.length === 1) {
      this.selectedDtoFolder = this.findFoldersByIds(this.rootDtoFolder, folderIds)[0];
    } else {
      this.selectedDtoFolder = undefined;
    }
  }

  onAutoSelectSubfoldersChanged(enabled: boolean): void {
    this.autoSelectSubfolders = enabled;

    this.directoryStateService.saveAutoSelectSubfolders(enabled).subscribe();
  }

  onExpandedFolderIdsChanged(folderIds: number[]): void {
    this.expandedFolderIds = folderIds;
    this.directoryStateService.saveExpandedFolders(folderIds).subscribe();
  }

  private setUrlToCurrentState(): void {
    this.location.replaceState(PathResolveService.getDirectoryManagementPath(true, this.getCurrentPackagingPartParam(), this.selectedFolderIds));
  }

  private getFolderIdsFromQueryParam(): number[] {
    const folderIdsParam = this.route.snapshot.queryParamMap.get(FolderIdsQueryParam);

    if (!folderIdsParam) {
      return [];
    }

    const folderIds = folderIdsParam
      .split(',')
      .map(value => Number(value.trim()))
      .filter(folderId => Number.isInteger(folderId) && folderId > 0);

    return [...new Set(folderIds)];
  }

  private setCurrentPackagingPartTable() {
    switch (this.selectedPackagingPartTab) {
      case PackagingPart.System:
        this.currentPackagingPartTable = this.packagingSystemsTable;
        this.currentDataSource = this.packagingSystemsDataSource;
        break;
      case PackagingPart.Unit:
        this.currentPackagingPartTable = this.packagingUnitsTable;
        this.currentDataSource = this.packagingUnitsDataSource;
        break;
      case PackagingPart.Component:
        this.currentPackagingPartTable = this.componentsTable;
        this.currentDataSource = this.componentsDataSource;
        break;
      case PackagingPart.Material:
        this.currentPackagingPartTable = this.materialsTable;
        this.currentDataSource = this.materialsDataSource;
        break;
      default:
        break;
    }
    this.setUrlToCurrentState();
  }

  private getCurrentPackagingPartParam() {
    return this.getPackagingPartParam(this.selectedPackagingPartTab);
  }

  private getPackagingPartParam(part: PackagingPart) {
    switch (part) {
      case PackagingPart.System:
        return PackagingSystemText;
      case PackagingPart.Unit:
        return PackagingUnitText;
      case PackagingPart.Component:
        return ComponentText;
      case PackagingPart.Material:
        return MaterialText;
      default:
        return PackagingSystemText;
    }
  }

  private updateIsEnterQuantitiesAllowed() {
    switch (this.selectedPackagingPartTab) {
      case PackagingPart.System:
      case PackagingPart.Unit:
        this.isEnterQuantitiesAllowed = true;
        break;
      case PackagingPart.Component:
      case PackagingPart.Material:
        this.isEnterQuantitiesAllowed = false;
        break;
      default:
        this.isEnterQuantitiesAllowed = false;
        break;
    }
  }

  private setPermissionsForCurrentFolder(directoryId: number) {
    this.getPermissionsSubscription = this.directoryApiService.determineCurrentUserPermissions(directoryId).subscribe(result => {
      this.directoryPermissions = {
        read: result.read,
        write: result.write,
        analyze: result.analyze,
        delete: result.delete,
      };
    });
  }

  private setPermissionsForSelectedFolders(folderIds: number[]): void {
    this.selectedFoldersPermissionsSubscription?.unsubscribe();

    if (folderIds.length === 0) {
      this.selectedFoldersPermissions = {
        read: false,
        write: false,
        analyze: false,
        delete: false,
      };

      return;
    }
    const permissionRequests = folderIds.map(folderId => this.directoryApiService.determineCurrentUserPermissions(folderId));
    this.selectedFoldersPermissionsSubscription = forkJoin(permissionRequests).subscribe(results => {
      this.selectedFoldersPermissions = {
        read: results.every(permission => permission.read),
        write: results.every(permission => permission.write),
        analyze: results.every(permission => permission.analyze),
        delete: results.every(permission => permission.delete),
      };
    });
  }

  onUserProfileChanged(profile: UserProfileDto): void {
    this.userProfile = profile;
  }

  onTabChanged() {
    this.resetPackagingPartSelection();
    this.setCurrentPackagingPartTable();
    this.updateIsEnterQuantitiesAllowed();
    if (this.selectedDtoFolder) {
      this.directoryStateService.saveFolderAndTab(this.selectedDtoFolder.id, this.selectedPackagingPartTab).subscribe();
    }
  }
  moveFolder(): void {
    this.contextMenuService.closeContextMenu();
    this.toolbar.moveFolder();
  }

  renameFolder() {
    this.toolbar.renameFolder();
  }

  removeFolder() {
    this.toolbar.removeFolder();
  }

  afterFolderRemoved() {
    this.getFoldersSubscription = this.directoryApiService.getDirectories().subscribe(rootDir => {
      this.rootDtoFolder = rootDir;
      this.updateView();
    });
  }

  afterTagsAssigned() {
    if (this.selectedPackagingPartTab === PackagingPart.Unit) {
      this.packagingUnitsTable?.cd.detectChanges();
    }
    this.resetPackagingPartSelection();
  }

  updateView() {
    this.directoryTree.updateDirectoryTreeData(this.rootDtoFolder);
    this.contextMenuService.closeContextMenu();
  }

  emptyRecyclingBin() {
    this.packagingSystemsTable?.emptyRecyclingBin();
    this.packagingUnitsTable?.emptyRecyclingBin();
    this.componentsTable?.emptyRecyclingBin();
    this.materialsTable?.emptyRecyclingBin();
  }

  restoreAllItemsFromRecyclingBin() {
    this.packagingSystemsTable?.restoreAllPackagingSystems();
    this.packagingUnitsTable?.restoreAllPackagingUnits();
    this.componentsTable?.restoreAllPackagingComponents();
    this.materialsTable?.restoreAllMaterials();
  }

  editTags() {
    this.assignTags(true);
  }

  addTags() {
    this.assignTags(false);
  }

  private assignTags(isEditing: boolean) {
    if (!this.currentPackagingPartTable) {
      return;
    }

    const getPackagingPartFunction: (id: number) => Observable<PackagingSystemDto | PackagingUnitDto | PackagingComponentDto | MultiMaterialCompositeDto | undefined> = isEditing
      ? this.currentPackagingPartTable.getPackagingPartFunction()
      : (_: number) => of(undefined);
    const tagsFunction = this.currentPackagingPartTable.getTagsSettingFunction(isEditing);

    getPackagingPartFunction(this.selectedEntryIds[0]).subscribe(itemToTag => {
      const itemIdsToTag = isEditing ? undefined : this.selectedEntryIds;

      const dialogConfig = getDialogConfig({ tags: this.allTags, item: itemToTag }, '800px');
      const dialogRef = this.dialog.open(SelectTagsDialogComponent, dialogConfig);
      this.dialogSubscription = dialogRef.afterClosed().subscribe(selectedTagIds => {
        if (!selectedTagIds) {
          return;
        }
        if (isEditing) {
          if (itemToTag === undefined || itemToTag.id == null) {
            return;
          }
          itemToTag.associatedTagIdentifiers = selectedTagIds;
          this.tagsSubscription = tagsFunction(itemToTag.id, selectedTagIds).subscribe(_ => {
            this.currentDataSource?.data
              .filter(x => x.id == itemToTag.id)
              .forEach(itemToTag => {
                itemToTag.associatedTagIdentifiers = selectedTagIds;
              });
          });
        } else {
          if (itemIdsToTag === undefined) {
            return;
          }
          for (const itemIdToTag of itemIdsToTag) {
            if (itemIdToTag != null) {
              this.tagsSubscription = tagsFunction(itemIdToTag, selectedTagIds).subscribe(tagIds => {
                this.currentDataSource?.data
                  .filter(x => x.id == itemIdToTag)
                  .forEach(itemToTag => {
                    itemToTag.associatedTagIdentifiers = tagIds;
                  });
              });
            }
          }
          if (this.selectedPackagingPartTab === PackagingPart.Unit) {
            this.packagingUnitsTable?.cd.detectChanges();
          }
        }
      });
      this.resetPackagingPartSelection();
    });
  }

  movePackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    const unreachableFolders = this.selectedDtoFolder ? [this.selectedDtoFolder] : this.findFoldersByIds(this.rootDtoFolder, this.selectedFolderIds);
    this.currentPackagingPartTable.movePackagingPart(this.rootDtoFolder, unreachableFolders);
  }

  private findFoldersByIds(folder: DirectoryDto, ids: number[]): DirectoryDto[] {
    const matches = ids.includes(folder.id) ? [folder] : [];
    return matches.concat(...folder.childDirectories.map(child => this.findFoldersByIds(child, ids)));
  }

  copyPackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.copyPackagingPart(this.rootDtoFolder, []);
  }

  deletePackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.deletePackagingPart();
  }

  restorePackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.restorePackagingPart();
  }

  exportPackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.exportPackagingPart();
  }

  createDataExchangeRequest() {
    if (this.isPpwrViewEnabled) {
      this.packagingPpwrTable?.createDataExchangeRequest();
    } else {
      this.currentPackagingPartTable?.createDataExchangeRequest();
    }
  }

  get isCreatingDataExchangeRequest(): boolean {
    const table = this.isPpwrViewEnabled ? this.packagingPpwrTable : this.currentPackagingPartTable;
    return table?.isCreatingDataExchangeRequest() ?? false;
  }

  createDoc() {
    this.packagingPpwrTable?.createDoc();
  }

  createTechnicalDoc() {
    this.packagingPpwrTable?.createTechnicalDoc();
  }

  comparePackagingPart() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.comparePackagingPart();
  }

  editPackagingPartQuantity() {
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.editPackagingPartQuantity();
  }

  private resetPackagingPartSelection() {
    if (this.isPpwrViewEnabled) {
      this.packagingPpwrTable?.clearSelection();
      return;
    }
    if (!this.currentPackagingPartTable) {
      return;
    }
    this.currentPackagingPartTable.resetSelection();
  }

  packagingEntriesSelected(selectedEntries: number[]): void {
    this.selectedEntryIds = selectedEntries;
  }

  downloadJson() {
    if (this.selectedPackagingPartTab === PackagingPart.System) {
      this.packagingSystemsTable?.downloadPackagingSystemsJson();
    }

    if (this.selectedPackagingPartTab === PackagingPart.Unit) {
      this.packagingUnitsTable?.downloadPackagingUnitsJson();
    }

    if (this.selectedPackagingPartTab === PackagingPart.Component) {
      this.componentsTable?.downloadPackagingComponentsJson();
    }

    if (this.selectedPackagingPartTab === PackagingPart.Material) {
      this.materialsTable?.downloadMultiMaterialsJson();
    }
  }

  downloadEXCEL() {
    if (this.selectedPackagingPartTab === PackagingPart.Unit) {
      this.packagingUnitsTable?.downloadPackagingUnitsEXCEL();
    }
  }

  onPpwrViewChanged(): void {
    this.selectedEntryIds = [];
    this.directoryStateService.savePpwrViewEnabled(this.isPpwrViewEnabled).subscribe();
    if (this.isPpwrViewEnabled && (this.selectedPackagingPartTab === PackagingPart.Component || this.selectedPackagingPartTab === PackagingPart.Material)) {
      this.selectedPackagingPartTab = PackagingPart.System;
    }
  }

  setInternalApproval(approved: boolean): void {
    const request: SetPpwrApprovedRequestDto = {
      packagings: this.selectedEntryIds.map(id => ({ id, version: undefined })),
      isApproved: approved,
    };

    this.packagingPpwrSystemTable?.showLoadingSpinner();
    this.packagingPpwrUnitTable?.showLoadingSpinner();

    const call =
      this.selectedPackagingPartTab === PackagingPart.System ? this.ppwrApiService.setPpwrApprovedForSystem(request) : this.ppwrApiService.setPpwrApprovedForUnit(request);

    call.subscribe({
      next: () => {
        this.packagingPpwrSystemTable?.resetSelection();
        this.packagingPpwrUnitTable?.resetSelection();
        this.updateView();
        this.showSnackbar('dataManagement.organizationSettings.messages.saveSuccess', 'app-success', 3000);
      },
      error: () => {
        this.showSnackbar('dataManagement.organizationSettings.messages.saveError', 'app-error', 4000);
      },
    });
  }

  private showSnackbar(messageKey: string, panelClass: string, duration: number): void {
    this.snackBar.open(this.translateService.translate(messageKey), this.translateService.translate('common.buttons.close'), {
      duration,
      panelClass: ['app-snackbar', panelClass],
    });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
    this.selectedFoldersSubscription?.unsubscribe();
    this.autoSelectSubfoldersSubscription?.unsubscribe();
    this.expandedFoldersSubscription?.unsubscribe();
    this.ppwrViewEnabledSubscription?.unsubscribe();
    this.selectedFoldersPermissionsSubscription?.unsubscribe();
    this.getPermissionsSubscription?.unsubscribe();
    this.dialogSubscription?.unsubscribe();
    this.getFoldersSubscription?.unsubscribe();
    this.tagsSubscription?.unsubscribe();
  }
}
